import * as React from "react";
import { AccordionDetails, AccordionSummary, Stack, Typography, styled } from "@mui/material";

import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import SmallAccordion from "../../Misc/SmallAccordion";

interface PanelAccordionProps {
  title: string;
  leftContent?: React.ReactNode;
  defaultExpanded?: boolean;
  children?: React.ReactNode;
}

const PanelAccordion: React.FC<PanelAccordionProps> = (props) => {
  const { title, defaultExpanded = true, children, leftContent, ...otherProps } = props;

  return (
    <>
      <StyledSmallAccordion defaultExpanded={defaultExpanded} {...otherProps}>
        <AccordionSummary expandIcon={<ExpandMoreRoundedIcon fontSize="small" sx={{ color: "text.tier" }} />}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="h6" color="text.tier">
              {title}
            </Typography>
            {leftContent}
          </Stack>
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </StyledSmallAccordion>
    </>
  );
};

export default PanelAccordion;

const StyledSmallAccordion = styled(SmallAccordion)(({ theme }) => ({
  background: "transparent",
  ".MuiAccordionSummary-root": {
    paddingLeft: 0,
    paddingRight: 0,
    "&.Mui-expanded": {
      minHeight: 48,
    },
  },
  ".MuiAccordionDetails-root": {
    borderColor: "transparent",
    padding: 0,
    paddingBottom: theme.spacing(2),
  },
  borderBottom: `1px solid ${theme.palette.backgroundAlpha.main}`,
}));
